module.exports = __webpack_public_path__ + "assets/img/146.0c642d10.png";